module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro-73b1ba650ee88f9ef498dd6f01bc5e23.webp";